import React from 'react'

import { useSaveAsset } from './_requests/saveAsset'
import { useAsset } from './_load/AssetLoader'
import FieldValuesFormSection from '../../../containers/fieldValues/form/FieldValuesFormSection'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/generalSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditAssetForm = () => {
  const asset = useAsset()
  const [onSubmit, { loading, error }] = useSaveAsset()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={asset || {}}>
      <GeneralSection />
      <FieldValuesFormSection origin="assets" />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditAssetForm
